export const types = {
  SET_CUSTOMER_CONTRACT: 'SET_CUSTOMER_CONTRACT',
  SET_CHOSEN_CONTRACT: 'SET_CHOSEN_CONTRACT',
  SET_LOADED: 'SET_LOADED',
};
